<template>
    <div
        class="absolute top-0 w-full flex justify-center"
    >
        <div
            ref="toggler"
            class="absolute w-fit select-none border border-base-300 shadow-sm py-0.5 px-2 bg-gradient-to-br from-base-100 to-base-200 cursor-pointer"
            @click="showMultiCreator = !showMultiCreator"
        >
            Debug <span class="text-xs">(Ctrl-Shift-d)</span>
        </div>
        <div
            v-if="showMultiCreator"
            ref="devMultiCreator"
            class="mt-2 border border-base-300 rounded p-2 bg-base-100 z-10 shadow-2xl w-fit h-fit flex flex-col gap-2"
            :style="floatingStyles"
        >
            <div class="my-1">For Debug: Masseinput av bilag</div>
            <div class="flex items-center gap-2">
                <button class="btn btn-xs bg-base-300" :disabled="isLoading" @click="multiCreate">
                    {{ isLoading ? 'Jobber...' : 'Opprett' }}
                </button>
                <input
                    v-model="multiCreateCount"
                    type="number"
                    class="input input-sm border border-base-300 rounded p-1 w-24"
                    autocomplete="off"
                >
                <label for="randomize-date">Tilfeldig dato (siste 365 dager)</label>
            </div>
            <div>
                <button class="btn btn-xs bg-base-300" @click="makeTransForAllAccounts">Lag transaksjon for alle kontoer!</button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import {TRANSACTION_CREATED} from '@/types/transaction/TransactionEvent'
import emitter from '@/services/infrastructure/emitter'
import hotkeys from 'hotkeys-js'
import {useFloating} from '@floating-ui/vue'
import {post} from '@/services/infrastructure/api.service'
import {bookkeepingAccounts} from '@/bookkeeping-account/bookkeepingAccount.service'
import {format} from 'date-fns'
import {generateTransactions} from '@/dummy-generator/DummyGenerator.service'
import {notifyError} from '@/services/infrastructure/notification.service'
import {onClickOutside} from '@vueuse/core'

const showMultiCreator = ref(false)
const toggler = ref(null)
const devMultiCreator = ref(null)
const {floatingStyles} = useFloating(toggler, devMultiCreator)

const multiCreateCount = ref(100)
const isLoading = ref(false)

const TRANSACTIONS_PATH = '/transactions'

onClickOutside(devMultiCreator, () => {
    showMultiCreator.value = false
}, {ignore: [toggler]})


const multiCreate = async () => {
    isLoading.value = true
    try {
        await generateTransactions(multiCreateCount.value)
    } catch (error: any) {
        notifyError({title: 'Feilet', description: {descriptionMessage: 'Klarte ikke å opprette transaksjoner', error}})
    } finally {
        isLoading.value = false
        emitter.emit(TRANSACTION_CREATED)
    }
}

const makeTransForAllAccounts = () => {
    const promises: Array<Promise<any>> = []
    bookkeepingAccounts.value
        .filter((account) => account.accountNo !== '1500')
        .filter((account) => account.accountNo !== '2400')
        .filter(account => !account.accountNo.startsWith('27'))
        .forEach(async (account) => {
            const randValue = Math.floor(Math.random() * 1000) + 100
            const description = `Trans for account ${account.accountNo}`
            const transaction = {
                description,
                transactionLines: [
                    {
                        accountNo: account.accountNo,
                        description,
                        amount: randValue,
                        date: format(new Date(), 'yyyy-MM-dd'),
                        vatOptionId: 1,
                        tags: []
                    },
                    {
                        accountNo: '1920',
                        description,
                        amount: randValue * -1,
                        date: format(new Date(), 'yyyy-MM-dd'),
                        vatOptionId: 1,
                        tags: []
                    }
                ]
            }
            promises.push(post(TRANSACTIONS_PATH, transaction))
        })
    Promise.all(promises).then(() => {
        emitter.emit(TRANSACTION_CREATED)
    })
}

hotkeys('ctrl+shift+d', () => {
    showMultiCreator.value = !showMultiCreator.value
})

</script>
